import { render } from "./PfInputDate.vue?vue&type=template&id=71db9174"
import script from "./PfInputDate.vue?vue&type=script&lang=js"
export * from "./PfInputDate.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__